

















import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import routenames from "../../modules/vRoutedefs";

@Component
export default class NewCard extends CommonBase {

    get cardConnectRoute() {
        return {path: routenames.start.card.add.path};
    }
}
